import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getAssignedItemsList } from '../../../../slices/thunks';
import SimpleBar from 'simplebar-react';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';

const AssignedItems = ({ title, establishment_id = null }) => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('1M');

    const [chartData, setChartData] = useState({ series: [], categories: [], fuelSummary: [] });

    const selectorPersonalProtectiveEquipment = createSelector(
        state => state.PersonalProtectiveEquipments,
        data => ({
            isLoading: data.isLoadingDashboardAssignedItems,
            dashboardAssignedItems: data.dashboardAssignedItems,
        })
    );

    const { isLoading, dashboardAssignedItems } = useSelector(selectorPersonalProtectiveEquipment);


    useEffect(() => {
        dispatch(getAssignedItemsList({ 'filter': selectedFilter, 'establishment_id': establishment_id }));
    }, []);

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
        dispatch(getAssignedItemsList({ 'filter': selectedFilter, 'establishment_id': establishment_id }));
    };

    if (isLoading) {
        return <OPlaceholder />;
    }


    return (
        <Card className='h-100 p-0 m-0'>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="flex-grow-1 m-0">{title}</h5>

                <div className='btn-box-dashboard'>
                    {/* <Button
                                            color={selectedFilter === 'AC' ? "primary" : "secondary"}
                                            size="sm"
                                            className={selectedFilter === 'AC' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                                            onClick={() => handleFilterChange('AC')}
                                            title="Ciclo Activo"
                                        >
                                            CA
                                        </Button> */}
                    <Button
                        color={selectedFilter === '1Y' ? "primary" : "secondary"}
                        size="sm"
                        className={selectedFilter === '1Y' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                        onClick={() => handleFilterChange('1Y')}
                        title="1 Año"
                    >
                        1A
                    </Button>
                    <Button
                        color={selectedFilter === '6M' ? "primary" : "secondary"}
                        size="sm"
                        className={selectedFilter === '6M' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                        onClick={() => handleFilterChange('6M')}
                        title="6 Meses"
                    >
                        6M
                    </Button>
                    <Button
                        color={selectedFilter === '3M' ? "primary" : "secondary"}
                        size="sm"
                        className={selectedFilter === '3M' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                        onClick={() => handleFilterChange('3M')}
                        title="3 Meses"
                    >
                        3M
                    </Button>
                    <Button
                        color={selectedFilter === '1M' ? "primary" : "secondary"}
                        size="sm"
                        className={selectedFilter === '1M' ? "btn-soft-primary" : "btn-soft-secondary"}
                        onClick={() => handleFilterChange('1M')}
                        title="1 Mes"
                    >
                        1M
                    </Button>
                </div>
            </CardHeader>
            <CardBody>
                <div className="table-responsive table-card">
                    <SimpleBar style={{ height: "320px" }}>
                        <table className="table table-sm table-striped table-hover table-borderless table-nowrap table-centered align-middle mb-0">
                            <thead className="table-light text-muted">
                                <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Cantidad</th>
                                    <th scope="col">Unidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboardAssignedItems || []).map((item, key) => (<tr key={key}>
                                    <td className="text-muted fs-11">{item.name}</td>
                                    <td className="text-muted fs-8">{item.quantity}</td>
                                    <td className="text-muted fs-11">{item.unit_measurement_name}</td>
                                </tr>))}
                            </tbody>
                        </table>
                    </SimpleBar>
                </div>
            </CardBody>
        </Card>
    );
};

export default AssignedItems;